// extracted by mini-css-extract-plugin
module.exports = {"skipLink":"navbar_skipLink__3TdC_"};